import { Component, Input, OnInit } from '@angular/core';
import { EventModel } from '@boxx/events-core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-appointment-item',
  templateUrl: './appointment-item.component.html',
  styleUrls: ['./appointment-item.component.scss'],
})
export class AppointmentItemComponent implements OnInit {
  @Input() showDetail = true;
  @Input() event: EventModel;
  @Input() eventDatetimeFrom: string;
  @Input() maxAttendeeToshow = 5;
  @Input() selected = false;

  constructor() {}

  ngOnInit() {}

  getDayNumber(date){
    const dateFormat = new Date(date);
    const dayNumber = dateFormat.getDate();
    return dayNumber;
  }

  getMonthNumber(date){
    const dateFormat = new Date(date);
    const monthNumber = dateFormat.getMonth()+1;
    return monthNumber;
  }

}
